import React from 'react'
import GridItem from "components/Grid/GridItem.js";
import { makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 25,
    marginBottom: 5,
  }
}))

function SubTitle(props){
  const classes = useStyles()
  const fieldsize = props.fieldsize ? props.fieldsize : 12

  return(
    <GridItem xs={12} sm={12} md={fieldsize}>
      <Typography variant="h6" className={classes.root}>{props.text}</Typography>
    </GridItem>
  )
}
export default SubTitle
